var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pos-rel"},[_c('audio',{staticClass:"full-width",attrs:{"src":_vm.src,"type":_vm._getAudMimeType(_vm.type),"controls":"","autoplay":_vm.autoplay}})])
}
var staticRenderFns = []

export { render, staticRenderFns }